import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPhone} = FiIcons;

const VideoSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.h2
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.6}}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
          >
            See Our AI Voice Technology in Action
          </motion.h2>
          <motion.p
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.6, delay: 0.1}}
            className="text-xl text-gray-600 max-w-4xl mx-auto mb-8"
          >
            Watch how our advanced AI voice receptionist handles real customer conversations with natural language processing and intelligent call routing capabilities. Experience the difference that professional AI technology can make for your business communications.
          </motion.p>
          <motion.div
            initial={{opacity: 0, y: 20}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.6, delay: 0.2}}
            className="text-lg text-gray-700 max-w-5xl mx-auto leading-relaxed"
          >
            <p className="mb-4">
              Our AI voice assistant demonstrates sophisticated conversation abilities, understanding context, intent, and emotional nuances in customer interactions. The system seamlessly handles appointment scheduling, call transfers, information requests, and complex customer service scenarios across various industries.
            </p>
            <p>
              Perfect for businesses throughout NYC and the Hudson Valley, our AI technology adapts to your specific industry requirements, whether you're operating a medical practice in Manhattan, a law firm in Brooklyn, or a real estate agency in Poughkeepsie.
            </p>
          </motion.div>
        </div>

        {/* Video - Single Vertical Video (formerly left side) */}
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8, delay: 0.2}}
          className="max-w-sm mx-auto"
        >
          <div className="bg-white rounded-2xl shadow-2xl p-4 md:p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
              Transform Your Calling Experience
            </h3>
            <p className="text-gray-600 mb-6 text-center">
              Discover how AI-powered calling bots revolutionize business communications
            </p>
            <div className="mx-auto">
              <div style={{position: 'relative', aspectRatio: '9/16'}}>
                <iframe
                  loading="lazy"
                  title="AI Calling Bot Transformation - Gumlet video player"
                  src="https://play.gumlet.io/embed/683089a836540bf132f2b0cb?background=false&autoplay=false&loop=false&disableControls=false"
                  style={{border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', borderRadius: '12px'}}
                  allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;fullscreen;"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </motion.div>

        {/* Technology Details Section */}
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.3}}
          className="mt-16 bg-white rounded-2xl p-8 shadow-lg"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Advanced AI Voice Technology Features
          </h3>
          <div className="grid md:grid-cols-3 gap-8 text-gray-700">
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">Natural Language Processing</h4>
              <p>
                Our AI voice assistant utilizes advanced natural language processing to understand customer intent, context, and emotional tone. The system can handle complex conversations, multiple topics, and nuanced requests with human-like comprehension.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">Intelligent Call Routing</h4>
              <p>
                Smart routing algorithms ensure every call reaches the right destination based on caller needs, urgency, and availability. The system learns from interaction patterns to optimize call distribution and reduce wait times.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">Real-Time Learning</h4>
              <p>
                Machine learning capabilities enable continuous improvement through every interaction. The AI adapts to your business terminology, processes, and customer preferences to provide increasingly personalized service.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Call to Action Below Videos */}
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.4}}
          className="text-center mt-12"
        >
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-2xl p-8 text-white max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Ready to Experience This Technology for Your Business?
            </h3>
            <p className="text-blue-100 mb-6 text-lg">
              Call our live demo line to interact with our AI voice assistant and discover how it can transform your customer service operations. Experience firsthand the professional, intelligent call handling that's revolutionizing business communications across NYC and the Hudson Valley.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="tel:+13322324531"
                className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-full font-semibold transition-colors duration-300 flex items-center gap-2"
              >
                📞 Try Demo: +1 332-232-4531
              </a>
              <button
                onClick={() => document.getElementById('pricing').scrollIntoView({behavior: 'smooth'})}
                className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors duration-300"
              >
                View Pricing Plans
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;